import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { TabContainer, StyledTab, StyledTabDisabledTooltip } from './Tabs.styles';

const Tabs = ({ tabs, onClick, selectedValue, className, overflowScroll = false, useHash = true }) => {
  const handleClick = (val) => {
    const tab = tabs.find((t) => t.value === val);
    if (tab.disabled) {
      return;
    }

    if (useHash) {
      const hash = `#${val}`;
      if (window.history.replaceState) {
        window.history.replaceState(null, null, hash);
      } else {
        window.location.hash = hash;
      }
    }
    onClick(val);
  };

  return (
    <TabContainer count={tabs.length} className={className} overflowScroll={overflowScroll} data-testid="search-tabs" data-cy="search-tabs">
      {tabs.map((tab) => (
        <StyledTab
          key={tab.value}
          data-testid={`search-tab-${tab.value}`}
          data-cy={`search-tab-${tab.value}`}
          onClick={() => handleClick(tab.value)}
          selected={tab.value === selectedValue}
          disabled={tab.disabled}
          disabledOnHoverMessage={tab.disabledOnHoverMessage}
        >
          {tab.label}
          {tab.disabled && tab.disabledOnHoverMessage && (
            <StyledTabDisabledTooltip>
              <FormattedMessage id={tab.disabledOnHoverMessage} />
            </StyledTabDisabledTooltip>
          )}
        </StyledTab>
      ))}
    </TabContainer>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.node
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  selectedValue: PropTypes.string.isRequired,
  useHash: PropTypes.bool,
  overflowScroll: PropTypes.bool
};

export default Tabs;
